import { render, staticRenderFns } from "./OrderContent.vue?vue&type=template&id=bc2aeab6"
import script from "./OrderContent.vue?vue&type=script&lang=js"
export * from "./OrderContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports